import type { Theme } from './useTheme.js'

/**
 * Shared dark/light toggle button — a round icon button with the
 * half-filled-circle glyph (mirrors the marketing site's toggle). It is
 * presentational: the caller passes the current theme + a toggle fn from
 * whichever app-specific hook (`useAdminTheme` / `useOwnerTheme`) owns the
 * state, plus a `className` so each app's CSS scope styles it.
 */
export function ThemeToggle({
  theme,
  toggle,
  className,
}: {
  theme: Theme
  toggle: () => void
  className: string
}) {
  const label = theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      className={className}
    >
      <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
        <circle
          cx="8"
          cy="8"
          r="6.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1"
        />
        <path d="M8 1.5 a6.5 6.5 0 0 1 0 13 z" fill="currentColor" />
      </svg>
    </button>
  )
}
